<div class="content-body-wrapper confirmation-popup">
    <h2 mat-dialog-title>Authentication Error</h2>
    <mat-dialog-content>
      <p class="font-size-14">Agent/Client has not been Authorised MTD into Capium. Please Authorise your Agent/Client and try again. <a href ="javascript:void" class="link text-primary" (click)="redirect()">Click here </a> to authorise        
      </p>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div>
          <button
            class="action-button secondary-button"
            type="button"
            mat-button
            disableRipple
            (click)="onCloseClick()"
          >
            Close
          </button>
        </div>
      </mat-dialog-actions>
  </div>
  